module.exports = __webpack_public_path__ + "img/neterror.e679f1b1.png";